import { render, staticRenderFns } from "./currencyList.vue?vue&type=template&id=71dab2ab&"
import script from "./currencyList.vue?vue&type=script&lang=js&"
export * from "./currencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports